import { DataTableDirective } from "@modules/common/components";
import { AddressService } from "@modules/common/components/address/address.service";
import { AddressDto, JobDto, ListResultDto } from "@shared/models";
import { JobService, ProductSettingService } from "../common/services";

export abstract class BaseJobList extends DataTableDirective {
  jobList: ListResultDto<JobDto>;
  loading = true;

  constructor(
    protected jobService: JobService,
    protected productSetting: ProductSettingService,
    protected address: AddressService
  ) {
    super("BaseJobList");
  }

  addressClass(address: AddressDto) {
    return this.address.getGpsQuality(address);
  }

  trackJob(index: number, item: JobDto) {
    return item.jobId;
  }
}
